
export class Epidemimie {
    id_epid:number;
    date_ajout:Date;
    nbr_teste:number;
    nbr_pers_epid : number;
    nbr_mort:number;
    text_epid:any;
    hafatra_pst:any;
    etat_epid:any;
    image_actu:any;

    
       
    constructor(id_epid:number){
           
    }
}
